import "./navbar.css";
import IMAGES from "../../images/images";
import { HashLink } from "react-router-hash-link";
import SoundBar from "../soundbar/SoundBar";


export default function navbar({ menuOpen, setMenuOpen}) {

    console.log("nav>>",menuOpen);
    
    return (
        <div className="navbar">
            <div className="navbar__wrapper">
                <div className="navbar__left">
                    <SoundBar menuOpen={menuOpen}/>
                </div>
                
                    <div className="navbar__center1" >
                        <HashLink smooth to="/">
                        <img src={IMAGES.logoQ} alt="" className={!menuOpen && "glow"}/>
                        </HashLink>
                    </div>
                
                <div className="navbar__right">
                    <div className={!menuOpen ? "actburg" :"navbar__hamburger"} onClick={()=>setMenuOpen(!menuOpen)}>
                        <span className="line1"></span>
                        <span   className="line2"></span>
                        <span className="line3"></span>
                    </div>
                </div>
            </div>
        </div>
    )
}
